import {OrbitComponent} from "../base-components/orbit-component/orbit-component";
import {IArenaViewModel} from "../../services/arenas/models/arenas/arena-view-model.interface";
import {observer} from "mobx-react";

interface SwiperWindowComponentProps {
    windowPosition: number;
    arena: IArenaViewModel;
}

@observer
export class SwiperWindowComponent extends OrbitComponent<SwiperWindowComponentProps> {

    render() {
        return this.props.arena.renderList(this.props.windowPosition);
    }
   
}